export default "__VITE_ASSET__803a0f5f__"